module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: [_vm.cssClass],
    attrs: {
      "role": "main"
    }
  }, [(_vm.navType === 'buttons') ? _c('nav', {
    class: [(_vm.cssClass + "-nav")],
    attrs: {
      "role": "navigation",
      "aria-label": "parallax navigation",
      "data-nav-position": _vm.navPosition
    }
  }, [_c('form', [_c('ul', _vm._l((_vm.nav), function(item, index) {
    return (_vm.nav.length) ? _c('li', {
      key: index
    }, [_c('label', {
      attrs: {
        "for": _vm.label(item),
        "title": index + 1
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentSection),
        expression: "currentSection"
      }],
      attrs: {
        "id": _vm.label(item),
        "aria-hidden": "true",
        "type": "radio",
        "name": _vm.cssClass
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.currentSection, item)
      },
      on: {
        "change": function($event) {
          _vm.currentSection = item
        }
      }
    }), _c('span')])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: [(_vm.cssClass + "-sections")]
  }, [_vm._t("default"), _vm._v(" "), _c('vc-style', [_vm._v("\n      html,\n      body,\n      ::-webkit-scrollbar\n      {\n        background: " + _vm._s(_vm.navColor) + ";\n      }\n\n      ::-webkit-scrollbar-corner,\n      ::-webkit-scrollbar-thumb\n      {\n        background: " + _vm._s(_vm.navAccentColor) + ";\n      }\n\n      .vc-parallax-nav,\n      .vc-parallax-nav span\n      {\n        border: solid 2px " + _vm._s(_vm.navColor) + ";\n      }\n\n      .vc-parallax-nav input:checked + span\n      {\n        background: " + _vm._s(_vm.navColor) + ";\n      }\n    ")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-555de7b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-parallax/parallax.vue
// module id = 48
// module chunks = 1